import React from 'react'
import { IWeatherTextsError } from '../../../types'

const WeatherError: React.FC<IWeatherTextsError> = ({ headLine, link }) => {
  return (
    <div className="error">
      <div className="errWrapper">
        <span className="error_icon" />
        <br />
        <span className="headline">{headLine}</span>
        <br />
        <span className="sub-headline">
          {link}{' '}
          <a href="https://accuweather.com">accuweather.com &reg;</a>
        </span>
      </div>
    </div>
  )
}

export default WeatherError
